

// export const mainContactPhone = "302-563-8156"
export const mainEmail = "pomeroycycles@gmail.com"
// export const mainContactPhoneLink = "tel:"+mainContactPhone
export const mainEmailLink = "mailto:"+mainEmail
